/** Parse API `is_vip` — boolean, 1, or string "true". */
export function parseIsVipFromApi(...values: unknown[]): boolean {
  for (const value of values) {
    if (value === true || value === 1 || value === "1") return true;
    if (typeof value === "string" && value.trim().toLowerCase() === "true") {
      return true;
    }
  }
  return false;
}

/** Parse API `is_sla` — boolean, 1, or string "true". Defaults OFF when absent. */
export function parseIsSlaFromApi(...values: unknown[]): boolean {
  for (const value of values) {
    if (value === true || value === 1 || value === "1") return true;
    if (typeof value === "string" && value.trim().toLowerCase() === "true") {
      return true;
    }
  }
  return false;
}

/**
 * Parse API `is_exit` — boolean, 1/0, or string "true"/"false".
 * Returns `undefined` when the field is absent/unrecognized so callers can
 * distinguish an explicit `false` from a missing value.
 */
export function parseIsExitFromApi(...values: unknown[]): boolean | undefined {
  for (const value of values) {
    if (value === true || value === 1 || value === "1") return true;
    if (value === false || value === 0 || value === "0") return false;
    if (typeof value === "string") {
      const s = value.trim().toLowerCase();
      if (s === "true") return true;
      if (s === "false") return false;
    }
  }
  return undefined;
}

/** Parse API `is_pts` using the same optional boolean rules as `is_exit`. */
export function parseIsPtsFromApi(...values: unknown[]): boolean | undefined {
  return parseIsExitFromApi(...values);
}
